import { handleActions } from 'redux-actions';
import * as types from '../constants/App';

export const getInitialState = () => ({
  appLoading: true,
  error: false,
  errorData: {},
  debugServices: false,
  debugErrors: false,
  modal: {
    active: false,
  },
});

const appHandler = (state, action) => {
  switch (action.type) {
    case types.APP_INITIAL: {
      const { payload } = action;
      return {
        ...state,
        ...payload.app,
      };
    }
    case types.APP_MODAL_ACTIVATOR: {
      return {
        modal: {
          ...(action.payload.active !== false ? state.modal : {}),
          ...action.payload,
        },
      };
    }
    case types.APP_LOADING: {
      return {
        appLoading: action.payload,
      };
    }
    case types.APP_ERROR: {
      const { payload } = action;
      return {
        appLoading: false,
        error: true,
        errorData: { ...payload },
      };
    }
    case types.APP_UPDATE_STATE: {
      const { payload } = action;
      return {
        ...state,
        ...payload,
      };
    }
    default:
      return {};
  }
};

const App = handleActions(
  {
    [types.APP_INITIAL]: (state, action) => ({
      ...state,
      ...appHandler(state, action),
    }),
    [types.APP_MODAL_ACTIVATOR]: (state, action) => ({
      ...state,
      ...appHandler(state, action),
    }),
    [types.APP_LOADING]: (state, action) => ({
      ...state,
      ...appHandler(state, action),
    }),
    [types.APP_INITIAL]: (state, action) => ({
      ...state,
      ...appHandler(state, action),
    }),
    [types.APP_ERROR]: (state, action) => ({
      ...state,
      ...appHandler(state, action),
    }),
    [types.APP_UPDATE_STATE]: (state, action) => ({
      ...state,
      ...appHandler(state, action),
    }),
  },
  getInitialState()
);

export default App;



// WEBPACK FOOTER //
// ./src/reducers/App.js